import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/user-genders/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const genders = {
  getAll: apiPathFunc(pathBase),
} as const;
